/**
 * @fileoverview gRPC-Web generated client stub for reconpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reconpb/balancerecon.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')

var utilspb_pagination_pb = require('../utilspb/pagination_pb.js')
const proto = {};
proto.reconpb = require('./balancerecon_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.BalanceReconServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.BalanceReconServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListBalanceReconRequest,
 *   !proto.reconpb.ListBalanceReconResponse>}
 */
const methodDescriptor_BalanceReconService_ListBalanceRecon = new grpc.web.MethodDescriptor(
  '/reconpb.BalanceReconService/ListBalanceRecon',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListBalanceReconRequest,
  proto.reconpb.ListBalanceReconResponse,
  /**
   * @param {!proto.reconpb.ListBalanceReconRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListBalanceReconResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListBalanceReconRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListBalanceReconResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListBalanceReconResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.BalanceReconServiceClient.prototype.listBalanceRecon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.BalanceReconService/ListBalanceRecon',
      request,
      metadata || {},
      methodDescriptor_BalanceReconService_ListBalanceRecon,
      callback);
};


/**
 * @param {!proto.reconpb.ListBalanceReconRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListBalanceReconResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.BalanceReconServicePromiseClient.prototype.listBalanceRecon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.BalanceReconService/ListBalanceRecon',
      request,
      metadata || {},
      methodDescriptor_BalanceReconService_ListBalanceRecon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListBalanceReconDetailRequest,
 *   !proto.reconpb.ListBalanceReconDetailResponse>}
 */
const methodDescriptor_BalanceReconService_ListBalanceReconDetail = new grpc.web.MethodDescriptor(
  '/reconpb.BalanceReconService/ListBalanceReconDetail',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListBalanceReconDetailRequest,
  proto.reconpb.ListBalanceReconDetailResponse,
  /**
   * @param {!proto.reconpb.ListBalanceReconDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListBalanceReconDetailResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListBalanceReconDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListBalanceReconDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListBalanceReconDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.BalanceReconServiceClient.prototype.listBalanceReconDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.BalanceReconService/ListBalanceReconDetail',
      request,
      metadata || {},
      methodDescriptor_BalanceReconService_ListBalanceReconDetail,
      callback);
};


/**
 * @param {!proto.reconpb.ListBalanceReconDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListBalanceReconDetailResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.BalanceReconServicePromiseClient.prototype.listBalanceReconDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.BalanceReconService/ListBalanceReconDetail',
      request,
      metadata || {},
      methodDescriptor_BalanceReconService_ListBalanceReconDetail);
};


module.exports = proto.reconpb;

